import isEmpty from 'lodash/isEmpty';
import replace from 'lodash/replace';

const DISALLOWED_CHAR_REGEX = /[^\p{L} \-.]+/gu;

export const MAX_PLAYER_NAME_LENGTH = 24;

const cleanupPlayerName = (name: string): string => {
	return replace(name, DISALLOWED_CHAR_REGEX, '');
};

const isAllowedPlayerName = (name: string): boolean => {
	return !isEmpty(name);
};

export { cleanupPlayerName, isAllowedPlayerName };
